import pclnData from './utils/pcln-data'
import { version } from './utils/string'

const data = () => {
  const PCLN_DATA = pclnData()

  return {
    NAME: 'PCLNAnalytics',
    VERSION: version('1.0.0'),
    APP_NAME: PCLN_DATA.appName || '',
    APP_VERSION: PCLN_DATA.appVersion || '',
    APP_LOCALE: PCLN_DATA.locale || '',
  }
}

const { NAME, VERSION, APP_NAME, APP_VERSION, APP_LOCALE } = data()

export { NAME, VERSION, APP_NAME, APP_VERSION, APP_LOCALE }

export default data
